<template>
  <section
    class="home"
    :class="{ scrolled: isScrolled }"
    data-t="bookmaker-home-page"
  >
    <MTopTournaments
      class="top-tournaments"
      :is-mini="isScrolled"
      data-t="top-tournaments"
    />
    <div class="live-link">
      <LiveNowLink :counter="liveCounter" />
    </div>
    <MHomeEvents :is-scrolled="isScrolled" class="home-events" />
  </section>
</template>

<script setup lang="ts">
import MHomeEvents from '../HomeEvents/MHomeEvents.vue'
import MTopTournaments from '../TopTournaments/MTopTournaments.vue'

const { isScrolled } = useScrolled({ offsetY: 10 })
const live = useLiveEvents()
const liveCounter = computed(() => live.value.length)
</script>

<style scoped>
.top-tournaments {
  position: sticky;
  z-index: 10;
  top: 48px;

  height: 68px;
  padding: var(--spacing-100) 0;
  padding-left: 0;

  background-color: var(--background-base);
}

.home-events {
  transform: translateY(42px);
  transition: transform 0.2s;
}

.live-link {
  transform: translateY(46px);
  padding: var(--spacing-200);
  background-color: var(--background-base);
  transition: transform 0.2s;
}

.home {
  &.scrolled {
    .home-events {
      transform: translateY(0);
    }

    .live-link {
      transform: translateY(0);
    }
  }
}
</style>
